module.exports = __webpack_public_path__ + "img/works-04_vue-googleMap.b540cb32.png";